import React  from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, notification, Popconfirm, Tooltip } from 'antd';
import { removeEmployee } from '../api/employeeApi';

const RemoveButton = ({ employee }) => {
  const remove = async () => {
    try {
      const { status } = await removeEmployee(employee);
      if (status === 200) {
        notification.success({
          message: 'Success',
          description: `${employee.fullName} is now being removed!`,
          placement: 'bottomRight',
        });
      } else {
        notification.warning({
          message: 'Error',
          description: `${employee.fullName} could not be removed.`,
          placement: 'bottomRight',
        });
      }
    } catch (e) {
      console.error(`Could not remove employee ${employee.email}`);
    }
  };

  return (
    <Tooltip title="Remove">
      <Popconfirm
        title={`Are you sure to remove ${employee.fullName} (this cannot be undone)?`}
        onConfirm={remove}
        okText="Yes"
        cancelText="No"
      >
        <Button icon={<DeleteOutlined />}></Button>
      </Popconfirm>
    </Tooltip>
  );
};

export { RemoveButton };
